module.exports = __webpack_public_path__ + "static/media/stankinWhiteLogo.13759ec5.png";